/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

import axios from 'axios'
import { ServicesListData } from '../types'

export const rootClient = axios.create({
  baseURL: process.env.VUE_APP_API_PROTOCOL + 'service-manager.' + process.env.VUE_APP_API_BASE_DOMAIN
})

export function fetchServicesList (): Promise<ServicesListData> {
  return new Promise((resolve, reject) => {
    rootClient.get(`/services`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export default {
  fetchServicesList
}
